import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import styles from './postboost.module.scss';

const PostBoostOption = ({
  icon,
  title,
  duration,
  oldPrice,
  price,
  buttonLabel,
  clickFunction,
}) => {
  return (
    <div className={styles.boostOption}>
      <img src={icon} width={60} height={60} />
      <div className="fs-28 lato-bold">{title}</div>
      <div className="fs-18">{duration}</div>
      {oldPrice && (
        <div className={'fs-18 ' + styles.oldPrice}>${oldPrice}</div>
      )}
      <div className="fs-20">${price}</div>
      <Button
        bsStyle="primary"
        name={'post-brief-boost-button-' + title}
        onClick={() => clickFunction()}
      >
        {buttonLabel}
      </Button>
    </div>
  );
};

PostBoostOption.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  duration: PropTypes.string,
  oldPrice: PropTypes.number,
  price: PropTypes.number,
  buttonLabel: PropTypes.string,
  clickFunction: PropTypes.func,
};

export default PostBoostOption;
